module.exports = __webpack_public_path__ + "static/media/cabal.d7faecd5.svg";